<template>
    <div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sort</label>
            </div>
            <div class="field-body">
                <div class="field is-narrow">
                    <div class="control">
                        <div class="select is-fullwidth">
                            <select v-model="sort" @change="loadPlayers">
                                <option
                                    v-for="s in sorts"
                                    :key="`sort_${s.name}_${s.lorder}`"
                                    :value="s"
                                >{{s.name}} {{s.lorder}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Search</label>
            </div>
            <div class="field-body">
                <div class="field is-narrow">
                    <div class="control">
                        <input v-model="searchQuery" type="text" placeholder="Number" class="input" />
                    </div>
                </div>
                <div class="field is-narrow">
                    <div class="control">
                        <a class="button" @click="loadPlayers()">Search</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="field">
            <div class="control">
                <router-link class="button is-success" :to="{'name':'create-player'}">Create player</router-link>
            </div>
        </div>

        <table class="table is-fullwidth is-hoverable is-size-7">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Login</th>
                    <th>Last login</th>
                    <th>Last acc.</th>
                    <th>Demo</th>
                    <th>Act.</th>
                    <th>Branch</th>
                    <th>Balance</th>
                    <th>Bonus</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <template v-for="player in players">
                    <template v-if="player.balances && player.balances.length">
                        <tr
                            v-for="(balance, index) in player.balances"
                            :key="`player_${player.number}_balance_${balance.id}`"
                        >
                            <td :rowspan="player.balances.length" v-if="index == 0">
                                <span
                                    v-if="player.isLocked"
                                    class="tag is-danger"
                                    :title="player.lockoutEndDate | datetime"
                                >LOCKED</span>
                                {{player.number}}
                            </td>
                            <td :rowspan="player.balances.length" v-if="index == 0">
                                <router-link
                                    :to="{ name: 'player', params: { clientId: clientId, playerId: player.id } }"
                                >
                                    {{ player.username }}
                                    <template
                                        v-if="player.alias"
                                    >/ {{player.alias}}</template>
                                </router-link>
                                <span v-if="player.lastIp" style="color:grey;">/ {{player.lastIp}}</span>
                            </td>
                            <td
                                :rowspan="player.balances.length"
                                v-if="index == 0"
                            >{{player.lastLogin | datetime}}</td>
                            <td
                                :rowspan="player.balances.length"
                                v-if="index == 0"
                            >{{player.lastAccess | datetime}}</td>
                            <td>
                                <span v-if="!balance.isDemo" class="tag is-light">real</span>
                                <span v-if="balance.isDemo" class="tag is-danger">demo</span>
                            </td>
                            <td>
                                <span v-if="balance.isActive" class="tag is-light">active</span>
                            </td>
                            <td>
                                <description :obj="balance" />
                            </td>
                            <td>{{balance.real | currency(balance.currency)}}</td>
                            <td>{{balance.bonus | currency(balance.currency)}}</td>
                            <td :rowspan="player.balances.length" v-if="index == 0">
                                <a
                                    v-if="player.isLocked"
                                    class="button is-small"
                                    @click="unlockPlayer(player)"
                                >Unlock</a>
                                <a
                                    v-else
                                    class="button is-warning is-small"
                                    @click="lockPlayer(player)"
                                >Lock</a>
                                <a
                                    class="button is-danger is-small"
                                    @click="deletePlayer(player)"
                                >Delete</a>
                            </td>
                        </tr>
                    </template>

                    <tr v-else :key="`player_${player.number}_no_balances`">
                        <td>{{player.number}}</td>
                        <td>
                            <router-link
                                :to="{ name: 'player', params: { clientId: clientId, playerId: player.id } }"
                            >{{ player.username }}</router-link>
                        </td>
                        <td>{{player.lastLogin | datetime}}</td>
                        <td>{{player.lastAccess | datetime}}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                            <a
                                v-if="player.isLocked"
                                class="button is-small"
                                @click="unlockPlayer(player)"
                            >Unlock</a>
                            <a
                                v-else
                                class="button is-warning is-small"
                                @click="lockPlayer(player)"
                            >Lock</a>
                            <a
                                class="button is-danger is-small"
                                @click="deletePlayer(player)"
                            >Delete</a>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>

        <pagination @change="loadPlayers();" ref="pagination" />
    </div>
</template>
<script>
import playerService from '../../../../services/player.service';

import pagination from '../../../common/pagination.vue';
import description from '../../../common/description.vue';
import currencyService from '../../../../services/currency.service';

export default {
    name: 'players-list',
    components: { pagination, description },
    data() {
        return {
            searchQuery: null,
            players: [],
            sorts: [
                { field: 'name', name: 'Name', order: 'Ascending', lorder: 'asc.' },
                { field: 'name', name: 'Name', order: 'Descending', lorder: 'desc.' },
                { field: 'll', name: 'Last login', order: 'Ascending', lorder: 'asc.' },
                { field: 'll', name: 'Last login', order: 'Descending', lorder: 'desc.' },
                { field: 'la', name: 'Last access', order: 'Ascending', lorder: 'asc.' },
                { field: 'la', name: 'Last access', order: 'Descending', lorder: 'desc.' },
                { field: '_reg', name: 'Registered', order: 'Ascending', lorder: 'asc.' },
                { field: '_reg', name: 'Registered', order: 'Descending', lorder: 'desc.' }
            ],
            sort: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        async clientId() {
            await this.loadPlayers();
        }
    },
    async mounted() {
        this.sort = this.sorts[5];
        await currencyService.ensure();
        await this.loadPlayers();
    },
    methods: {
        async loadPlayers() {
            const filter = {
                pageNumber: this.$refs.pagination.pageNumber,
                pageSize: this.$refs.pagination.pageSize,
                sortBy: this.$data.sort.field,
                sortOrder: this.$data.sort.order,
                searchQuery: this.searchQuery
            };
            const data = await playerService.getByClient(this.clientId, filter);
            this.players = data.items;
            this.$refs.pagination.set(data.pageNumber, data.totalPages);
        },
        async lockPlayer(player) {
            if (confirm('Are you sure you want to lock player ' + player.username + '?')) {
                await playerService.lock(player.id);
                await this.loadPlayers();
            }
        },
        async unlockPlayer(player) {
            if (confirm('Are you sure you want to unlock player ' + player.username + '?')) {
                await playerService.unlock(player.id);
                await this.loadPlayers();
            }
        },
        async deletePlayer(player) {
            if (confirm('Are you sure you want to TOTALLY DELETE player ' + player.username + '?')) {
                await playerService.delete(player.id);
                await this.loadPlayers();
            }
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/list.vue